import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";
import "../GoogleLogin/GoogleLogin.css"
import { APIUrl, APIUrlToken, SetlocalStorage } from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import { useAuth0 } from "@auth0/auth0-react";
const GoogleLoginCustom = () => {
  const navigate = useNavigate();
  const { loginWithRedirect } = useAuth0();

  // const login = useGoogleLogin({
  //   onSuccess: (tokenResponse) => {
  //     fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
  //       headers: {
  //         Authorization: `Bearer ${tokenResponse.access_token}`,
  //       },
  //     })
  //       .then((res) => res.json())
  //       .then((user) => {
  //         handleDashboardClick(user)
  //         // navigate("/dashboard");
  //       })
  //       .catch((err) =>
  //   },
  //   onError: () => {
  //   },
  // });
  const handleDashboardClick = async (user) => {
    const data = {
      "user_google_id": user?.sub,
      "user_name": user?.name,
      "user_profile_pic": user?.picture,
      "user_email": user?.email
    }
    const url = `${APIUrl()}/v1/local/auth/auth/google-login`;
    const options = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: url,
    };

    try {
      const response = await axios(options);
      SetlocalStorage("isAdmin", response.data?.is_admin)
      SetlocalStorage("nilToken", response.data)
      toast.success("User Logged in successfully!");
      navigate("/")
    } catch (error) {

      toast.error(error?.response?.data?.detail || "Error creating user. Please try again.");
    } finally {
    }
  };
  return (

    <button onClick={() => loginWithRedirect()} className="google-login-btn">
      <FcGoogle className="google-logo" />
      Login with Google
    </button>
  );
};

export default GoogleLoginCustom;